function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "2bbp5xmaaa",
  d: "M0 0L18.2 0 18.2 11.6 0 11.6z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#D88314",
  d: "M9.1 3.4c-1.32 0-2.4 1.08-2.4 2.4 0 1.32 1.08 2.4 2.4 2.4 1.32 0 2.4-1.08 2.4-2.4 0-1.32-1.08-2.4-2.4-2.4",
  transform: "translate(-1129 -352) translate(1129 350) translate(0 2)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1129 -352) translate(1129 350) translate(0 2)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "6yvyqxknfb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#2bbp5xmaaa"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#D88314",
  d: "M9.1 9.4c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6m8.98-3.96c-.04-.04-1-1.36-2.58-2.7C13.38.94 11.16 0 9.1 0 4.16 0 .28 5.22.12 5.44c-.16.22-.16.5 0 .7.04.06 1 1.38 2.58 2.72 2.12 1.8 4.34 2.74 6.4 2.74 4.94 0 8.82-5.22 8.98-5.44.16-.22.16-.5 0-.72",
  mask: "url(#6yvyqxknfb)"
}))))));

function SvgViewerRole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewerRole);
export default __webpack_public_path__ + "static/media/viewer-role.f3c3aedc.svg";
export { ForwardRef as ReactComponent };